import { get } from 'lodash';

export default function() {
  'ngInject';
  return product => {
    const instructors = get(product, 'instructors', undefined);
    const by = get(product, 'by', '');

    if (!instructors) return by;

    return instructors.map(({ first, last }) => `${first} ${last}`).join(', ');
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/Instructors.js